'use client';

import { Toaster } from 'sonner';
import { NextIntlClientProvider } from 'next-intl';
import { type ReactNode } from 'react';
import { CompanyStatisticsProvider } from '@/components/analytics/CompanyStatisticsTracker';
import { PostHogProvider } from '@/components/analytics/PostHogProvider';
import { GoogleAnalyticsPageView } from '@/components/analytics/GoogleAnalyticsPageView';
import { PublicAnalyticsPageView } from '@/components/analytics/PublicAnalyticsPageView';

export const Providers = ({
  children,
  locale,
  messages,
  timeZone,
}: {
  children: ReactNode;
  locale: string;
  messages: Record<string, unknown>;
  timeZone: string;
}) => {
  return (
    <NextIntlClientProvider 
      locale={locale} 
      messages={messages}
      timeZone={timeZone}
    >
      <PostHogProvider>
        <CompanyStatisticsProvider>{children}</CompanyStatisticsProvider>
        <Toaster position="top-right" richColors />
        <PublicAnalyticsPageView />
        <GoogleAnalyticsPageView />
      </PostHogProvider>
    </NextIntlClientProvider>
  );
};
